import { render } from "./StockMovement.vue?vue&type=template&id=69893af5"
import script from "./StockMovement.vue?vue&type=script&lang=js"
export * from "./StockMovement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__